import styled from 'styled-components';

export const StyledCleaningPlanEvent = styled.div`
  &.rbc-event {
    border: 1px solid ${(props): string => props.theme.colors.brightGrey};
    background-color: ${(props): string => props.theme.colors.celadonGreen};
    border-radius: 0;
    z-index: 2;
    display: block;
    padding: 5px;
  }

  &:hover {
    z-index: 4;
  }

  &.cleaning-plan-event--more {
    background-color: ${(props): string => props.theme.colors.white};
    color: ${(props): string => props.theme.colors.grey400};
    cursor: pointer;
    text-align: left;
    font: inherit;
    width: 100%;
    box-sizing: border-box;

    .cleaning-plan-event__event-name {
      color: ${(props): string => props.theme.colors.grey400};
      margin-bottom: 0;
    }
  }

  .cleaning-plan-event__event-name {
    font-family: ${(props): string => props.theme.fonts.captionMedium};
    font-size: ${(props): string => props.theme.fontSizes.caption};
    line-height: ${(props): string => props.theme.lineHeights.caption};
    font-weight: ${(props): number => props.theme.fontWeights.captionMedium};
    color: ${(props): string => props.theme.colors.white};
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 14px;
    max-height: 28px;

    &--single-line {
      -webkit-line-clamp: 1;
      max-height: 14px;
    }
  }

  .cleaning-plan-event__time-span {
    font-family: ${(props): string => props.theme.fonts.captionNews};
    font-size: ${(props): string => props.theme.fontSizes.caption};
    line-height: ${(props): string => props.theme.lineHeights.caption};
    font-weight: ${(props): number => props.theme.fontWeights.captionNews};
    color: ${(props): string => props.theme.colors.white};
    opacity: 70%;
    line-height: 14px;
    margin: 0;
    ${(props): string => props.theme.mixins.truncateText}
  }
`;

export const StyledCleaningPlanMoreEvents = styled.div`
  min-width: 180px;
  max-width: 240px;

  .cleaning-plan-more-events__list {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 240px;
    overflow-y: auto;
  }

  .cleaning-plan-more-events__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 8px 4px;
    cursor: pointer;

    &:hover {
      background-color: ${(props): string => props.theme.colors.brighterGrey};
    }
  }

  .cleaning-plan-more-events__name {
    ${(props): string => props.theme.fontStyles.redesign.sm.strong}
    color: ${(props): string => props.theme.colors.black};
  }

  .cleaning-plan-more-events__time {
    ${(props): string => props.theme.fontStyles.redesign.sm.normal}
    color: ${(props): string => props.theme.colors.grey200};
  }
`;
